import React, { PureComponent } from 'react'
import { View, Image, FlatList, StyleSheet, Dimensions, Animated } from 'react-native'
import styled from 'styled-components/native'

import Alert from '../../Atoms/Alert'
import PageHeader from '../../Molecules/PageHeader'

import Button from '../../Atoms/Button'
import OptionsAlert from '../../Molecules/OptionsAlert'
import Touchable from '../../Atoms/Touchable'
import { Text } from '../../Atoms/Typography'
import theme from '../../../styles/theme'
import Impact from './Impact'

const carouselHeight = 160 + (theme.gutterUnit * 2)

const projectImages = {
  1: require('../../../assets/images/projects/project1.jpg'),
  2: require('../../../assets/images/projects/project2.jpg'),
  3: require('../../../assets/images/projects/project3.jpg'),
  4: require('../../../assets/images/projects/project4.jpg'),
  5: require('../../../assets/images/projects/project5.jpg'),
  6: require('../../../assets/images/projects/project6.jpg'),
  7: require('../../../assets/images/projects/project7.jpg'),
  8: require('../../../assets/images/projects/project8.jpg'),
  9: require('../../../assets/images/projects/project9.jpg'),
  10: require('../../../assets/images/projects/project10.jpg'),
  11: require('../../../assets/images/projects/project11.jpg'),
  12: require('../../../assets/images/projects/project12.jpg'),
  13: require('../../../assets/images/projects/project13.jpg'),
  14: require('../../../assets/images/projects/project14.jpg'),
  15: require('../../../assets/images/projects/project15.jpg'),
  16: require('../../../assets/images/projects/project16.jpg'),
  17: require('../../../assets/images/projects/project17.jpg')
}

const completedImage = require('../../../assets/images/projects/completed.png')
const selectedImage = require('../../../assets/images/projects/selected.png')

const Container = styled(View)`
  flex: 1;
  flex-direction: column;
`

const Carousel = styled(View)`
  background-color: white;
  height: ${carouselHeight}px;
  padding: ${theme.gutterUnit}px;
`

const Content = styled(View)`
  flex: 1;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
`

const ButtonContainer = styled(View)`
  flex-direction: row;
  align-items: center;
`

const ProjectDetails = styled(View)`
  width: ${props => props.width}px;
  height: 100%;
  padding-left: ${theme.gutterUnit}px;
  padding-top: ${theme.gutterUnit}px;
`

const ImageContainer = styled(View)`
  border: 2px ${theme.colours.bordergrey} solid;
`

const ImpactWidgetContainer = styled(View)`
  flex-grow: 1;
  justify-content: space-around;
`

const ImpactBar = styled(View)`
  width: ${props => props.width}px;
  height: 100%;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${theme.gutterUnit}px;
  padding-top: ${theme.gutterUnit}px;
`

const ImageHeaderBar = styled(View)`
  position: absolute;
  height: ${props => props.height}px;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: ${theme.colours.black};
  opacity: 0.5;
`

const ImageText = styled(View)`
  position: absolute;
  height: ${props => props.height}px;
  left: 0;
  bottom: 0;
  right: 0;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-left: ${2 * theme.gutterUnit}px;
  padding-right: ${2 * theme.gutterUnit}px;
`

const OngoingCost = styled(View)`
  position: absolute;
  height: ${props => props.height}px;
  left: 0;
  bottom: 0;
  right: 0;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: ${2 * theme.gutterUnit}px;
  padding-bottom: ${theme.gutterUnit / 2}px;
`

const ProjectButtons = styled(View)`
  margin-top: ${theme.gutterUnit}px;
  align-items: center;
`

const ImpactContainer = styled(View)`
  width: 100%;
  flex-grow: 1;
  padding-left: ${theme.gutterUnit}px;
  padding-right: ${theme.gutterUnit}px;
`

const ImpactHeading = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: ${theme.gutterUnit / 4}px;
`

export default class SpecialProjects extends PureComponent {
  state = {
    dimensions: null,
    showProjectAlert: false,
    showOptionSelection: false
  }

  constructor (props) {
    super(props)
    this.imageOpacity = new Animated.Value(1)
  }

  handleLayout = event => {
    const { width, height } = event.nativeEvent.layout
    if (this.state.dimensions && this.state.dimensions.width === width && this.state.dimensions.height === height) return // layout was already called
    this.setState({
      dimensions: { width, height }
    })
  }

  componentDidUpdate (prevProps) {
    if (this.props.sidebarWidth && prevProps.sidebarWidth) {
      if (this.props.sidebarWidth !== prevProps.sidebarWidth) {
        this.setState({ dimensions: null })
      }
    }
    if (this.props.selectedProject !== prevProps.selectedProject) {
      Animated.parallel([
        Animated.timing(this.imageOpacity, {
          duration: 1000,
          toValue: 1
        })
      ]).start()
    }
  }

  onSelectProject = (project) => {
    this.imageOpacity = new Animated.Value(0)
    this.props.onSelectProject(project)
  }

  onSubmit = () => {
    if (this.props.onHandleSubmit()) {
      this.setState({ showProjectAlert: true })
    } else {
      this.handleSubmit()
    }
  }

  handleSubmit = () => {
    this.handleCancel()
    if (this.props.canSubmit()) {
      this.props.submitProject()
    } else {
      this.setState({ showOptionSelection: true })
    }
  }

  handleCancel = () => {
    if (this.state.showProjectAlert) {
      this.setState({ showProjectAlert: false })
    }
    if (this.state.showOptionSelection) {
      this.setState({ showOptionSelection: false })
    }
  }

  handleCancelOption = () => {
    this.handleCancel()
    this.props.onDeselectBusiness()
  }

  render () {
    const { items, selectedProject, round, submitButtonEnabled, onDeselectProject, selectedBusiness, onSelectBusiness } = this.props
    const selectedItem = selectedProject ? items.find(it => it.id === selectedProject) : null
    let selectedBusinessValue = selectedBusiness || ''
    if (!selectedBusinessValue && selectedItem && selectedItem.options && selectedItem.businessId) {
      selectedBusinessValue = selectedItem.businessId
    }

    const selectedItemHasBusinessId = !!(selectedItem && selectedItem.businessId)

    const availableHeight = (Dimensions.get('window').height - theme.headerHeight - theme.teamBarHeight - carouselHeight)
    const imageHeight = availableHeight / 1.8
    const imageHeaderHeight = availableHeight / 2 / 3
    const projectDetailsWidth = this.state.dimensions ? this.state.dimensions.width - (this.state.dimensions.width / 4) : 0

    return (
      <Container>
        <PageHeader text='PROJECT PORTFOLIO' />
        <Alert
          visible={this.state.showProjectAlert}
          onCancel={this.handleCancel}
          onConfirm={this.handleSubmit}
        >
          <Text size='xxl' overrides={[{ marginBottom: theme.gutterUnit / 2 }]}>Change project</Text>
          <Text size='s'>Are you sure you want to change the selected project?</Text>
        </Alert>
        <Content onLayout={this.handleLayout}>
          {this.state.dimensions && selectedItem && (
            <>
              <ProjectDetails width={projectDetailsWidth}>
                <ImageContainer>
                  <Animated.Image
                    style={{
                      width: projectDetailsWidth - theme.gutterUnit - 4, // 4 is border width
                      height: imageHeight,
                      resizeMode: 'cover',
                      opacity: this.imageOpacity
                    }}
                    source={projectImages[selectedItem.id]}
                  />
                  <ImageHeaderBar height={imageHeaderHeight} />
                  <ImageText height={imageHeaderHeight}>
                    <View>
                      <Text white size='xxl'>{selectedItem.name.toUpperCase()}</Text>
                      <Text white size='l'>{selectedItem.areaOfFocus}</Text>
                    </View>
                    <View>
                      <Text white size='huge'>{selectedItem.cost}</Text>
                    </View>
                  </ImageText>
                  {!!selectedItem.ongoingCost && (
                    <OngoingCost height={imageHeaderHeight}>
                      <Text white fontSize={17}>{`+${selectedItem.ongoingCost} p.a`}</Text>
                    </OngoingCost>
                  )}
                </ImageContainer>
                <Text medium size='l' overrides={{ marginTop: theme.gutterUnit }}>PROJECT OVERVIEW</Text>
                <Text size='s' overrides={{ lineHeight: 28 }}>{selectedItem.description}</Text>
              </ProjectDetails>
              <ImpactBar width={this.state.dimensions.width / 4}>
                {/* <Text centre>IMPACTS</Text> */}
                <ImpactContainer>
                  <ImpactHeading>
                    <Text fontSize={12} bold>{'< NEGATIVE IMPACT'}</Text>
                    <Text fontSize={12} bold>{'POSITIVE IMPACT >'}</Text>
                  </ImpactHeading>
                  <ImpactWidgetContainer>
                    {selectedItem.impacts.filter(i => i.enabled).map((impact, i) => (
                      <Impact key={i} name={impact.name} value={impact.value} />
                    ))}
                  </ImpactWidgetContainer>
                </ImpactContainer>
                <ProjectButtons>
                  {!!selectedItem.options && (
                    <View style={{
                      // marginRight: theme.gutterUnit,
                      marginBottom: theme.gutterUnit / 4
                    }}
                    >
                      <OptionsAlert
                        visible={this.state.showOptionSelection}
                        onCancel={this.handleCancelOption}
                        onConfirm={this.handleSubmit}
                        title='Select product to market'
                        options={selectedItem.options.map(o => {
                          return {
                            value: o.value,
                            name: o.label,
                            handlePress: () => onSelectBusiness(o.value),
                            selected: o.value === selectedBusinessValue
                          }
                        })}
                      />
                      {selectedItemHasBusinessId && (
                        <>
                          <Text size='s'>Marketing Focus</Text>
                          <Text bold>{selectedItem.options.find(o => o.value === selectedItem.businessId).label}</Text>
                        </>
                      )}
                    </View>
                  )}
                  {submitButtonEnabled && selectedItem.usedInRound === null && (
                    <ButtonContainer>
                      <Button
                        block noborder rounded colour={theme.colours.blue} styles={[{
                          marginRight: theme.gutterUnit / 2,
                          marginBottom: theme.gutterUnit / 2,
                          height: 50
                        }]} onPress={() => { this.onSubmit() }}
                      >
                        <Text
                          white medium size='xl' overrides={{
                            marginRight: 3.6 * theme.gutterUnit,
                            marginLeft: 3.6 * theme.gutterUnit
                          }}
                        >SELECT
                        </Text>
                      </Button>
                    </ButtonContainer>
                  )}
                  {selectedItem.usedInRound === round && (
                    <ButtonContainer>
                      <Button
                        block noborder rounded colour={theme.colours.orange} styles={[{
                          marginRight: theme.gutterUnit / 2,
                          marginBottom: theme.gutterUnit / 2,
                          height: 50
                        }]} onPress={() => { if (submitButtonEnabled) { onDeselectProject() } }}
                      >
                        <Text
                          black medium size='xl' overrides={{
                            marginRight: 2 * theme.gutterUnit,
                            marginLeft: 2 * theme.gutterUnit
                          }}
                        >SELECTED
                        </Text>
                      </Button>
                    </ButtonContainer>
                  )}
                </ProjectButtons>
              </ImpactBar>
            </>
          )}
        </Content>
        <Carousel>
          <FlatList
            horizontal
            data={items}
            extraData={{ selectedProject }}
            renderItem={({ item }) => {
              return (
                <Touchable
                  onPress={() => this.onSelectProject(item.id)}
                  touchableStyle={{ paddingRight: theme.gutterUnit }}
                >
                  <Image style={{ height: carouselHeight - 2 * theme.gutterUnit, width: 260, resizeMode: 'cover' }} source={projectImages[item.id]} />
                  {selectedProject !== item.id && (
                    <View style={{
                      ...StyleSheet.absoluteFillObject,
                      backgroundColor: theme.colours.blue,
                      opacity: 0.9
                    }}
                    />
                  )}
                  {selectedProject === item.id && (
                    <View style={{
                      ...StyleSheet.absoluteFillObject,
                      backgroundColor: theme.colours.black,
                      opacity: 0.5
                    }}
                    />
                  )}
                  {item.usedInRound !== null && item.usedInRound < round &&
                    <View style={{
                      ...StyleSheet.absoluteFillObject,
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    >
                      <Image source={completedImage} style={{ height: carouselHeight - 2 * theme.gutterUnit, width: 260, resizeMode: 'cover' }} />
                    </View>}
                  {item.usedInRound !== null && item.usedInRound === round &&
                    <View style={{
                      ...StyleSheet.absoluteFillObject,
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                    >
                      <Image source={selectedImage} style={{ height: carouselHeight - 2 * theme.gutterUnit, width: 260, resizeMode: 'cover' }} />
                    </View>}
                  <View style={{
                    ...StyleSheet.absoluteFillObject,
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                  >
                    <Text white medium size='l'>{item.name.toUpperCase()}</Text>
                    <Text white size='m'>{item.areaOfFocus}</Text>
                    <Text white medium size='l' overrides={{ paddingTop: theme.gutterUnit * 1.5 }}>{item.cost}</Text>
                  </View>
                </Touchable>
              )
            }}
            keyExtractor={(item, index) => String(index)}
          />
        </Carousel>
      </Container>
    )
  }
}
